import PropTypes from 'prop-types';
import ProductProp from './ProductProp';
import PackProp from './PackProp';
import DiscountProp from './DiscountProp';
import PlanProp from './PlanProp';

const propType = {
  numberUsers: PropTypes.number.isRequired,
  numberAdmins: PropTypes.number.isRequired,
  plan: PropTypes.shape(PlanProp.propType),
  packs: PropTypes.arrayOf(
    PropTypes.shape({
      product: PropTypes.shape(PackProp.propType).isRequired,
      quantity: PropTypes.number.isRequired,
      interval: PropTypes.string,
    }),
  ).isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      product: PropTypes.shape(ProductProp.propType).isRequired,
      quantity: PropTypes.number.isRequired,
      interval: PropTypes.string,
    }),
  ).isRequired,
  subscriptions: PropTypes.arrayOf(
    PropTypes.shape({
      product: PropTypes.shape(ProductProp.propType).isRequired,
      quantity: PropTypes.number.isRequired,
      interval: PropTypes.string,
    }),
  ).isRequired,
  discounts: PropTypes.arrayOf(PropTypes.shape(DiscountProp.propType))
    .isRequired,
};

export default { propType };
